const TextDescription = ({ title, color }) => {
  return (
    <span style={{ fontFamily: "MSPAINT" }} className={`text-lg leading-[33px] text-${color} font-ComicSansMS`}>
      {title}
    </span>
  );
};

export default TextDescription;
